export interface RouteLocation {
  pathname: string
  search?: string
  hash?: string
}

export interface ShouldUpdateScrollArgs {
  prevRouterProps?: { location: RouteLocation } | null
  routerProps: { location: RouteLocation }
  getSavedScrollPosition: (location: RouteLocation) => [number, number] | null
}

/** Scroll to top on pathname changes; keep position for hash-only nav and browser back. */
export const shouldUpdateScroll = ({
  prevRouterProps,
  routerProps,
  getSavedScrollPosition,
}: ShouldUpdateScrollArgs): [number, number] | boolean => {
  const { location } = routerProps

  if (prevRouterProps?.location.pathname === location.pathname) {
    return false
  }

  const saved = getSavedScrollPosition(location)
  if (saved) {
    return saved
  }

  return [0, 0]
}

export const scrollToTop = (): void => {
  if (typeof window === "undefined") {
    return
  }

  window.scrollTo({ top: 0, left: 0, behavior: "instant" })
}

/** Call from Gatsby onRouteUpdate after client-side navigations. */
export const scrollToTopOnRouteUpdate = ({
  location,
  prevLocation,
}: {
  location: RouteLocation
  prevLocation: RouteLocation | null
}): void => {
  if (!prevLocation || location.pathname === prevLocation.pathname) {
    return
  }

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(scrollToTop)
  })
}
